var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoteDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0714 9.53647V13.7868C15.0714 14.4574 14.5277 15.0011 13.8571 15.0011H1.71341C1.04273 15.0011 0.499043 14.4574 0.499043 13.7868V9.53647C0.499043 9.20113 0.770888 8.92929 1.10623 8.92929C1.44156 8.92929 1.71341 9.20113 1.71341 9.53647V13.7868H13.8571V9.53647C13.8571 9.20113 14.1289 8.92929 14.4642 8.92929C14.7996 8.92929 15.0714 9.20113 15.0714 9.53647ZM7.35565 9.96605C7.46954 10.0801 7.62408 10.1441 7.78524 10.1441C7.94639 10.1441 8.10093 10.0801 8.21482 9.96605L11.2507 6.93014C11.488 6.69289 11.488 6.30823 11.2507 6.07098C11.0135 5.83372 10.6288 5.83372 10.3916 6.07098L8.39242 8.07088V1.03591C8.39242 0.700576 8.12057 0.428731 7.78524 0.428731C7.4499 0.428731 7.17805 0.700576 7.17805 1.03591V8.07088L5.1789 6.07098C4.94165 5.83372 4.55699 5.83372 4.31974 6.07098C4.08249 6.30823 4.08249 6.69289 4.31974 6.93014L7.35565 9.96605Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteDownload);
export default __webpack_public_path__ + "static/media/QuoteDownload.3728c8b57eda5e9fe93ab5da284483d5.svg";
export { ForwardRef as ReactComponent };